import React from 'react';

function LoadingFallback() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        color: '#091021',
        fontWeight: 600,
      }}
    >
      Carregando...
    </div>
  );
}

export default LoadingFallback;
